import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI

import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';
import SensorsIcon from "@mui/icons-material/Sensors"; // Ícone para Zonas
import AccountTreeIcon from "@mui/icons-material/AccountTree"; // Ícone para Partições
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';
import Hls from "hls.js";

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import { Card, CardContent } from "@mui/material";

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Modal from "react-modal";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';



import api from '../../../../../../services/api';


import NavegadorGestao from "../../../../../../components/NavBarGestao";


import switch_off from '../../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../../assets/imgs/icone_call.png';


import cabo_conectado from '../../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../../assets/imgs/cabo_conectado.png';

import modem_conectado from '../../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../../configs/globalConfigs';





import alarmeAudio from '../../../../../../assets/mp3/alarme.mp3';
import LocationOnIcon from '@mui/icons-material/LocationOn';

// Replaced react-leaflet with raw Leaflet for stability in mixed MUI environments
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;




export default function ModuloPGMComponent({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag }) {


    //const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag } = props;
    const tempoInativo = 3;

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);





    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const [openLogTable, setOpenLogTable] = useState(false);

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    // Control for Map Hover display without breaking React-Leaflet Context
    const [showMap, setShowMap] = useState(false);
    const [mapReady, setMapReady] = useState(false);
    const mapRef = useRef(null);

    useEffect(() => {
        setMapReady(true);
    }, []);

    // Manual Leaflet init to avoid Context Errors
    useEffect(() => {
        if (showMap && mapReady && mapRef.current && (equipamento.modulo_pgm.latitude || lat)) {
            const mapLat = parseFloat(equipamento.modulo_pgm.latitude || lat);
            const mapLng = parseFloat(equipamento.modulo_pgm.longitude || lng);
            
            // Brief timeout to ensure div is rendered and has dimensions
            const timeoutId = setTimeout(() => {
                if (!mapRef.current) return;
                
                const map = L.map(mapRef.current).setView([mapLat, mapLng], 16);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);
                
                L.marker([mapLat, mapLng]).addTo(map);
                
                return () => {
                    map.remove();
                };
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [showMap, mapReady, equipamento.modulo_pgm.latitude, equipamento.modulo_pgm.longitude, lat, lng]);

    // Map Modal State
    const [openModalMap, setOpenModalMap] = useState(false);
    const modalMapRef = useRef(null);

    // Modal Map Init
    useEffect(() => {
        if (openModalMap && modalMapRef.current) {
            const mapLat = parseFloat(equipamento.modulo_pgm.latitude || lat);
            const mapLng = parseFloat(equipamento.modulo_pgm.longitude || lng);

            const timeoutId = setTimeout(() => {
                if (!modalMapRef.current) return;
                
                const map = L.map(modalMapRef.current).setView([mapLat, mapLng], 14);
                
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);

                L.marker([mapLat, mapLng]).addTo(map)
                    .bindPopup(`<b>${equipamento.nome}</b><br/>${equipamento.modulo_pgm.codigo}`)
                    .openPopup();

                return () => {
                    map.remove();
                };
            }, 400); 

            return () => clearTimeout(timeoutId);
        }
    }, [openModalMap, lat, lng, equipamento.nome, equipamento.modulo_pgm.codigo]);

    const [logsPgm, setLogsPgm] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [isFetchingLogs, setIsFetchingLogs] = useState(false);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [customSearch, setCustomSearch] = useState('');

    const [openAlarmeImage, setOpenAlarmeImage] = useState(false);
    const [selectedAlarmeImageUrl, setSelectedAlarmeImageUrl] = useState(null);
    const [selectedAlarmeData, setSelectedAlarmeData] = useState(null);

    const filteredLogs = useMemo(() => {
        if (!logsPgm) return [];
        if (!customSearch.trim()) return logsPgm;
        const term = customSearch.toLowerCase();
        return logsPgm.filter(row => {
            const id = String(row.id_tarefa || '');
            const user = String(row.usuario_criador?.nome_amigavel || row.usuario_criador?.nome || row.usuario_nome || row.nome_usuario || row.usuario || '');
            const req = String(row.data_hora_requisicao || '');
            const resp = String(row.data_hora_resposta || '');
            const tipo = String(row.tipo_requisicao || '');
            const val1 = String(row.valor_string1 || row.valor_string || '');
            const val2 = String(row.valor_string2 || '');
            const val3 = String(row.valor_string3 || '');
            const origem = String(row.origem || '');
            return id.toLowerCase().includes(term) ||
                   user.toLowerCase().includes(term) ||
                   req.toLowerCase().includes(term) ||
                   resp.toLowerCase().includes(term) ||
                   tipo.toLowerCase().includes(term) ||
                   val1.toLowerCase().includes(term) ||
                   val2.toLowerCase().includes(term) ||
                   val3.toLowerCase().includes(term) ||
                   origem.toLowerCase().includes(term);
        });
    }, [logsPgm, customSearch]);

    const processVideoUrl = (url) => {
        if (!url) return null;
        let processedUrl = url;
        processedUrl = processedUrl.replace('/home/wwgrup/alarmes/', 'https://gruporosinetos.com/alarmemidias/');
        return processedUrl;
    };

    const [estadoArmacaoLocal, setEstadoArmacaoLocal] = useState(() => {
        return equipamento?.modulo_pgm?.estado_armacao_modulo ?? 0;
    });
    const [loadingArmacao, setLoadingArmacao] = useState(false);
    const [countdownArmacao, setCountdownArmacao] = useState(10);

    useEffect(() => {
        if (!loadingArmacao && equipamento?.modulo_pgm?.estado_armacao_modulo !== undefined) {
            setEstadoArmacaoLocal(equipamento.modulo_pgm.estado_armacao_modulo);
        }
    }, [equipamento?.modulo_pgm?.estado_armacao_modulo, loadingArmacao]);


    function processarIcone(tipo) {
        if (tipo === 0) {
            return icone_pgm;
        } else if (tipo === 10) {
            return icone_medidor;
        } else if (tipo === 70) {
            return icone_central;
        } else if (tipo === 30) {
            return icone_pgm;
        } else if (tipo === 120) {
            return icone_corneta;
        }
    }


    const tipoRequisicaoMap = {
        0: "Acionar Ambos Reles",
        1: "Acionar Rele 1",
        2: "Acionar Rele 2",
        3: "Desligar Ambos Reles",
        4: "Desligar Rele 1",
        5: "Desligar Rele 2",
        6: "Reproduzir Audio Personalizado 1",
        7: "Reproduzir Audio Personalizado 2",
        8: "Reproduzir Audio Personalizado 3",
        9: "Reproduzir Audio Personalizado 4",
        10: "Reproduzir Audio Personalizado 5",
        20: "Desativar Automação Geral",
        21: "Ativar Automação Geral",
        22: "Reiniciar PGM",
        23: "Desativar Automação dos Reles",
        24: "Ativar Automação dos Reles",
        25: "Desativar Automação da Corneta",
        26: "Ativar Automação da Corneta",
        27: "Armar Central em Stay",
        28: "Armar Central em Away",
        29: "Desativar Central",
        40: "Arme do Modulo Unifier",
        41: "Desarme do Modulo Unifier",
        50: "Central Armada",
        51: "Central Desarmada",
        52: "Central em Alarme",
        90: "ALARME DE CAMERA VIA PGM",
        92: "Reconhecimento Facial",
        223: "Reiniciar a Central",
        70: "ATUALIZAR PGM",
        700: "PGM REINICIOU",
        8801: "ARME LOCAL DO MODULO",
        8802: "DESARME LOCAL DO MODULO",
        900: "ScreenShot"

    };

    const respondidoModuloPgmMap = {
        0: "Não Respondido",
        1: "Respondido"
    };

    const processarDadosLogs = (dados) => {
        return dados.map((item) => ({
            ...item, // Mantém os outros atributos
            data_hora_requisicao: moment(item.data_hora_requisicao).isValid()
                ? moment(item.data_hora_requisicao).format('HH:mm:ss DD/MM/YYYY')
                : item.data_hora_requisicao, // Formata a data ou mantém o valor original
            data_hora_resposta: moment(item.data_hora_resposta).isValid()
                ? moment(item.data_hora_resposta).format('HH:mm:ss DD/MM/YYYY')
                : item.data_hora_resposta, // Formata a data ou mantém o valor original
            tipo_requisicao: tipoRequisicaoMap[item.tipo_requisicao] || "Tipo Desconhecido", // Mapeia o tipo
            origem: item.origem === 0 ? "Local" : "Remoto", // Mapeia a origem
            respondido_modulo_pgm: respondidoModuloPgmMap[item.respondido_modulo_pgm] || "Status Desconhecido", // Mapeia o status de respondido
        }));
    };


    useEffect(() => {
        if (openLogTable) {
            fetchLogsData();
        }
    }, [pagination.pageIndex, pagination.pageSize, openLogTable]);

    async function fetchLogsData(pi = pagination.pageIndex, ps = pagination.pageSize) {
        setIsFetchingLogs(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const offset = pi * ps;
            const url = `/v1/protected/modulopgm/tarefas/listarpagina/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + ps + "/" + offset;
            const response = await api.get(url, { headers });

            if (response.data && response.data.data) {
                setLogsPgm(processarDadosLogs(response.data.data));
                setRowCount(response.data.total);
            } else if (Array.isArray(response.data)) {
                const dados = processarDadosLogs(response.data);
                setLogsPgm(dados);
                setRowCount(dados.length);
            }
        } catch (error) {
            console.error("Erro ao buscar logs:", error);
            try {
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const urlFallback = `/v1/protected/modulopgm/tarefas/listartodasparaareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/200";
                const responseFallback = await api.get(urlFallback, { headers });
                if (responseFallback.data) {
                    const dados = processarDadosLogs(responseFallback.data);
                    setLogsPgm(dados);
                    setRowCount(dados.length);
                }
            } catch (errFallback) {
                console.error("Erro no fallback de logs:", errFallback);
            }
        } finally {
            setIsFetchingLogs(false);
        }
    }

    async function handleClickLog() {
        setPagination({ pageIndex: 0, pageSize: 10 });
        setOpenLogTable(true);
        fetchLogsData(0, 10);
    }

    const extractEventString = (row) => {
        const logData = (row.valor_string1 || '') + ' ' + (row.valor_string2 || '') + ' ' + (row.valor_string3 || '');
        let tipoEvento = row.tipo_requisicao || 'N/A';
        if (logData.includes('Tipo:')) {
            const match = logData.match(/Tipo:\s*([^|]+)/);
            if (match) tipoEvento = match[1].trim();
        }

        let ipDispositivo = row.valor_string1 || row.origem || 'N/A';
        if (logData.includes('IP Câmera:')) {
            const match = logData.match(/IP Câmera:\s*([^|]+)/);
            if (match) ipDispositivo = match[1].trim();
        } else if (logData.includes('IP:')) {
            const match = logData.match(/IP:\s*([^|]+)/);
            if (match) ipDispositivo = match[1].trim();
        }

        let idEquipamento = row.id_equipamento && row.id_equipamento !== 0 ? String(row.id_equipamento) : 'N/A';
        if (logData.includes('ID Equipamento:')) {
            const match = logData.match(/ID Equipamento:\s*([^|]+)/);
            if (match) idEquipamento = match[1].trim();
        }

        let nomeZona = 'N/A';
        if (row.valor_string3 && row.valor_string3 !== 'null') {
            nomeZona = row.valor_string3;
        } else if (logData.includes('Zona:')) {
            const match = logData.match(/Zona:\s*([^|]+)/);
            if (match) nomeZona = match[1].trim();
        }

        let result = `Evento: ${tipoEvento}\nIP: ${ipDispositivo}`;
        if (idEquipamento !== 'N/A') result += `\nID: ${idEquipamento}`;
        if (nomeZona !== 'N/A') result += `\nZona: ${nomeZona}`;
        return result;
    };

    const getExportData = () => {
        const dataToExport = filteredLogs.length > 0 ? filteredLogs : logsPgm;
        return dataToExport.map((log) => {
            const infoExtra = log.valor_string2 ? log.valor_string2.replace(/\\n/g, '\n') : '';
            const user = log.usuario_criador?.nome_amigavel || log.usuario_criador?.nome || log.usuario_nome || log.nome_usuario || '-';
            return {
                'ID': log.id_tarefa,
                'Usuário': user,
                'Data Requisição': log.data_hora_requisicao,
                'Data Resposta': log.data_hora_resposta || '-',
                'Tipo': log.tipo_requisicao,
                'Evento': extractEventString(log),
                'Info Extra': infoExtra,
                'Origem': log.origem,
                'Respondido': log.respondido_modulo_pgm
            };
        });
    };

    const handleExportDataPDF = () => {
        const doc = new jsPDF('l'); 
        const exportData = getExportData();
        if (exportData.length === 0) return;
        
        const head = [Object.keys(exportData[0])];
        const tableData = exportData.map(obj => Object.values(obj));
        
        autoTable(doc, {
            head: head,
            body: tableData,
            styles: { cellWidth: 'wrap', fontSize: 8 },
            columnStyles: {
                5: { cellWidth: 70 }, 
                6: { cellWidth: 60 }  
            }
        });
        doc.save('historico_eventos_modulo_pgm.pdf');
    };

    const handleExportDataExcel = () => {
        const exportData = getExportData();
        if (exportData.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        
        const colWidths = [];
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
            let max = 15; 
            for (let R = range.s.r; R <= range.e.r; ++R) {
                const cell = worksheet[XLSX.utils.encode_cell({c: C, r: R})];
                if (cell && cell.v) {
                    if (cell.t === 's') {
                        cell.s = { alignment: { wrapText: true } };
                    }
                    const lines = cell.v.toString().split('\n');
                    lines.forEach(line => {
                        if (line.length > max) max = line.length;
                    });
                }
            }
            colWidths[C] = { wch: max + 2 };
        }
        worksheet['!cols'] = colWidths;
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Eventos");
        XLSX.writeFile(workbook, "historico_eventos_modulo_pgm.xlsx");
    };



    async function handleClickPgm(comando) {

        console.log("handleClickPgm")

        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);


            }



        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }


    async function handleClickAtualizar() {

        console.log("handleClickAtualizar")

        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/70";
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);


            }



        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }




    async function handleArmarDesarmarLocal() {
        if (loadingArmacao) return;

        const acaoArmar = (estadoArmacaoLocal === 0);
        const comando = acaoArmar ? 8801 : 8802;
        const estadoAlvo = acaoArmar ? 1 : 0;

        setLoadingArmacao(true);
        setCountdownArmacao(10);

        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
            await api.get(url, { headers });

            setSnackbarMessage(acaoArmar ? 'Comando ARMAR LOCAL enviado! Aguardando confirmação do módulo...' : 'Comando DESARMAR LOCAL enviado! Aguardando confirmação do módulo...');
            setSnackbarSeverity('info');
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Erro ao enviar comando de armação local:", error);
            setSnackbarMessage('Erro ao enviar comando para o módulo');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoadingArmacao(false);
            return;
        }

        let segundosRestantes = 10;
        let mudou = false;

        const timerId = setInterval(async () => {
            segundosRestantes -= 1;
            setCountdownArmacao(segundosRestantes);

            try {
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const checkUrl = `/v1/protected/modulopgm/listarporid/${equipamento.modulo_pgm.id_modulo_pgm}`;
                const checkRes = await api.get(checkUrl, { headers });
                if (checkRes.data && checkRes.data.estado_armacao_modulo === estadoAlvo) {
                    mudou = true;
                    clearInterval(timerId);
                    setEstadoArmacaoLocal(estadoAlvo);
                    if (equipamento && equipamento.modulo_pgm) {
                        equipamento.modulo_pgm.estado_armacao_modulo = estadoAlvo;
                    }
                    setLoadingArmacao(false);
                    setSnackbarMessage(estadoAlvo === 1 ? 'Módulo ARMADO LOCALMENTE com sucesso!' : 'Módulo DESARMADO LOCALMENTE com sucesso!');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);
                    return;
                }
            } catch (e) {
                // Silencioso durante polling
            }

            if (segundosRestantes <= 0) {
                clearInterval(timerId);
                setLoadingArmacao(false);
                if (!mudou) {
                    setSnackbarMessage('Tempo limite de 10s esgotado. O módulo permaneceu no estado anterior.');
                    setSnackbarSeverity('warning');
                    setSnackbarOpen(true);
                }
            }
        }, 1000);
    }

    const processarIndexAtivarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 1;
        } else if (index === 2) {
            //rele 2
            return 2;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -1;
        }
    }

    const processarIndexDesativarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 4;
        } else if (index === 2) {
            //rele 2
            return 5;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -2;
        }
    }

    // Calcular a diferença de tempo
    const now = new Date();
    const lastResponse = new Date(equipamento.modulo_pgm.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

    // Verificar se o alarme deve ser ativado
    const alarme = equipamento.alarme;

    // Definir o estado do equipamento
    let statusText;
    let statusColor;
    let isBlinking = false;

    const armada = equipamento.modulo_pgm.armada;
    
    // Status Logic Enhancement
    const hasStatusCentral = !!equipamento.modulo_pgm.status_central;
    const anyZoneArmed = (equipamento.modulo_pgm.status_zonas || "").split(";").some(linha => {
        const partes = linha.split(",");
        if (partes.length < 4) return false; // Ignorar linhas vazias ou mal formatadas
        const s = (partes[3] || "").toLowerCase().trim();
        // Considera armada se for "Armada", "true" ou "1"
        return s === "armada" || s === "true" || s === "1";
    });

    let effectiveArmada = armada;
    if (!hasStatusCentral) {
        // Se partições em branco, consideramos ARMADA se pelo menos uma zona reportar estado de armada.
        effectiveArmada = anyZoneArmed;
    }

    if (alarme) {
        statusText = "ALARME";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver em alarme
    } else if (differenceInMinutes < tempoInativo) {
        if (effectiveArmada) {
            statusText = "ONLINE - ARMADA";
            statusColor = "green";
        }
        else {
            statusText = "ONLINE - DESARMADA";
            statusColor = "orange";
        }
    } else {
        statusText = "OFFLINE";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver offline
    }



    const Zone = ({ zoneData }) => {

        const {
            id,
            nome,
            zoneStatus,
            armeStatus,
            zoneAlarme,
        } = zoneData;

        return (
            <Card sx={{ margin: 2, padding: 2, backgroundColor: darkMode ? '#1e293b' : '#f5f5f5', color: darkMode ? '#f8fafc' : 'inherit' }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Zona {id}: {nome}
                    </Typography>
                    <Box sx={{ whiteSpace: "pre-line" }}>
                        <Typography><b>Online?</b> {zoneStatus}  </Typography>
                        <Typography><b>Armada?</b> {armeStatus}  </Typography>
                        <Typography><b>Em Alarme?</b> {zoneAlarme}</Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    };



    return (
        <>
            {flag === 1 ? (
                <div style={{
                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                    borderRadius: '16px',
                    padding: '24px',
                    margin: '8px 0',
                    width: '100%',
                    fontFamily: '"Rajdhani", "Roboto", "Segoe UI", sans-serif',
                    boxShadow: darkMode ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.08)',
                    border: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                }}>
                    {/* HEADER IOT */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0', paddingBottom: '16px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{
                                position: 'relative',
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                <img src={processarIcone(tipo)} alt="icon" style={{ width: '48px', height: '48px', position: 'relative', zIndex: 2, filter: darkMode ? 'invert(1)' : 'none' }} />
                                <div style={{
                                    position: 'absolute',
                                    width: '56px', height: '56px',
                                    borderRadius: '50%',
                                    backgroundColor: alarme ? '#ef4444' : (statusColor === 'green' ? '#10b981' : '#f59e0b'),
                                    opacity: 0.2,
                                    animation: isBlinking ? 'blink 2s infinite' : 'none',
                                    zIndex: 1
                                }} />
                            </div>
                            <div>
                                <Typography style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.5px', color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1.2 }}>
                                    TITANIWM PGM <span style={{ color: '#10b981', fontSize: '0.8rem', backgroundColor: 'rgba(16, 185, 129, 0.1)', padding: '2px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px' }}>v{equipamento.modulo_pgm.firmware_version}</span>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                    <Typography style={{ fontSize: '0.85rem', color: darkMode ? '#94a3b8' : '#64748b', fontFamily: 'monospace' }}>
                                        UUID: {equipamento.modulo_pgm.codigo}
                                    </Typography>
                                    <Tooltip title="Configurações da PGM" PopperProps={{ sx: { zIndex: 11000 } }}>
                                        <div
                                            onClick={() => {
                                                const url = `/gestao/administracao/equipamentos/editarequipamento/${equipamento.id_equipamento}/1/${id_instalacao}/0`;
                                                window.open(url, '_blank');
                                            }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer',
                                                backgroundColor: darkMode ? 'rgba(99, 102, 241, 0.12)' : 'rgba(99, 102, 241, 0.08)',
                                                padding: '2px 8px', borderRadius: '12px',
                                                border: darkMode ? '1px solid rgba(99, 102, 241, 0.3)' : '1px solid rgba(99, 102, 241, 0.25)',
                                                transition: 'all 0.2s ease-in-out'
                                            }}
                                        >
                                            <SettingsIcon style={{ fontSize: '0.85rem', color: darkMode ? '#818cf8' : '#6366f1' }} />
                                            <Typography style={{ fontSize: '0.65rem', fontWeight: 800, color: darkMode ? '#818cf8' : '#6366f1', letterSpacing: '0.5px' }}>
                                                CONFIG
                                            </Typography>
                                        </div>
                                    </Tooltip>

                                    {(equipamento.modulo_pgm.latitude || lat) !== undefined && (
                                        <div 
                                            style={{ position: 'relative' }}
                                            onMouseEnter={() => setShowMap(true)}
                                            onMouseLeave={() => setShowMap(false)}
                                            onClick={() => setOpenModalMap(true)}
                                        >
                                            <div style={{ 
                                                display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer',
                                                backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.1)' : 'rgba(14, 165, 233, 0.1)',
                                                padding: '2px 8px', borderRadius: '12px', border: darkMode ? '1px solid rgba(56, 189, 248, 0.2)' : '1px solid rgba(14, 165, 233, 0.2)',
                                                transition: 'all 0.2s ease-in-out'
                                            }}>
                                                <LocationOnIcon style={{ fontSize: '0.9rem', color: darkMode ? '#38bdf8' : '#0ea5e9' }} />
                                                <Typography style={{ fontSize: '0.65rem', fontWeight: 800, color: darkMode ? '#38bdf8' : '#0ea5e9', letterSpacing:'0.5px' }}>
                                                    LOCALIZAÇÃO
                                                </Typography>
                                            </div>

                                            {showMap && mapReady && (
                                                <div style={{ 
                                                    position: 'absolute', top: '100%', left: 0, zIndex: 9999,
                                                    width: '320px', paddingTop: '8px'
                                                }}>
                                                    <div style={{
                                                        padding: '8px', borderRadius: '8px',
                                                        backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                                        boxShadow: '0 10px 25px rgba(0,0,0,0.5)', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                                                    }}>
                                                        <div 
                                                            ref={mapRef}
                                                            style={{ height: '180px', width: '100%', borderRadius: '8px', overflow:'hidden', backgroundColor:'#f0f0f0' }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '4px' }}>
                                {estadoArmacaoLocal === 0 ? (
                                    <button
                                        onClick={handleArmarDesarmarLocal}
                                        disabled={loadingArmacao}
                                        style={{
                                            backgroundColor: loadingArmacao ? '#94a3b8' : '#10b981',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '4px 12px',
                                            fontSize: '0.75rem',
                                            fontWeight: 700,
                                            cursor: loadingArmacao ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.2s',
                                            textTransform: 'uppercase',
                                            boxShadow: loadingArmacao ? 'none' : '0 0 10px rgba(16,185,129,0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        {loadingArmacao ? `⏳ AGUARDANDO (${countdownArmacao}s)` : '🛡️ ARMAR LOCAL'}
                                    </button>
                                ) : (
                                    <button
                                        onClick={handleArmarDesarmarLocal}
                                        disabled={loadingArmacao}
                                        style={{
                                            backgroundColor: loadingArmacao ? '#94a3b8' : '#ef4444',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '4px 12px',
                                            fontSize: '0.75rem',
                                            fontWeight: 700,
                                            cursor: loadingArmacao ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.2s',
                                            textTransform: 'uppercase',
                                            boxShadow: loadingArmacao ? 'none' : '0 0 10px rgba(239,68,68,0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        {loadingArmacao ? `⏳ AGUARDANDO (${countdownArmacao}s)` : '🔓 DESARMAR LOCAL'}
                                    </button>
                                )}
                                <button onClick={handleClickLog} style={{ backgroundColor: darkMode ? '#334155' : '#e2e8f0', color: darkMode ? '#f8fafc' : '#0f172a', border: 'none', borderRadius: '6px', padding: '4px 12px', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s', textTransform: 'uppercase' }}>📜 REGISTROS</button>
                                {Cookies.get("regra").includes("ROOT_MASTER") && (
                                    <button onClick={handleClickAtualizar} style={{ backgroundColor: '#10b981', color: '#fff', border: 'none', borderRadius: '6px', padding: '4px 12px', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s', textTransform: 'uppercase', boxShadow: '0 0 10px rgba(16,185,129,0.3)' }}>⟳ ATUALIZAR</button>
                                )}
                            </div>
                            <div style={{ 
                                backgroundColor: alarme ? 'rgba(239,68,68,0.1)' : (statusColor === 'green' ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)'),
                                color: alarme ? '#ef4444' : (statusColor === 'green' ? '#10b981' : '#f59e0b'),
                                padding: '6px 16px',
                                borderRadius: '24px',
                                border: `1px solid ${alarme ? 'rgba(239,68,68,0.3)' : (statusColor === 'green' ? 'rgba(16,185,129,0.3)' : 'rgba(245,158,11,0.3)')}`,
                                fontWeight: 700,
                                fontSize: '0.8rem',
                                letterSpacing: '0.5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                boxShadow: alarme ? '0 0 15px rgba(239,68,68,0.2)' : 'none'
                            }}>
                                {isBlinking && <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor', animation: 'blink 1s step-start infinite' }}/>}
                                {statusText}
                            </div>
                            <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#64748b' : '#94a3b8', fontFamily: 'monospace' }}>
                                ÚLT. SINCRONISMO: {equipamento.modulo_pgm.data_hora_ultima_resposta ? moment(equipamento.modulo_pgm.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss DD/MM/YY") : 'N/A'}
                            </Typography>
                        </div>
                    </div>

                    {/* TELEMETRY & COMMAND DASHBOARD */}
                    <Grid container spacing={3}>
                        {/* RELAYS CONTROL PANEL */}
                        <Grid item xs={12} md={7}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                borderRadius: '12px',
                                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%',
                                position: 'relative',
                                overflow: 'hidden',
                                display: 'flex', flexDirection: 'column',
                                boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><PowerSettingsNewIcon fontSize="small"/> ATUADORES DE RELÉ </span>
                                    <span style={{ color: '#3b82f6', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.7rem', animation: 'pulse 2s infinite' }}>CANAIS 1-4</span>
                                </div>
                                <div style={{ padding: '16px', flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Grid container spacing={2}>
                                        {[1, 2, 3, 4].map((index) => {
                                            const releNome = equipamento?.modulo_pgm[`nome_rele${index}`] || `Relé ${index}`;
                                            const status = equipamento?.modulo_pgm[`status_rele${index}`];
                                            const isOn = status === "on";
                                            return (
                                                <Grid item xs={12} sm={6} key={index}>
                                                    <div style={{
                                                        backgroundColor: isOn ? (darkMode ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.05)') : (darkMode ? '#0f172a' : '#f8fafc'),
                                                        border: isOn ? '1px solid #10b981' : (darkMode ? '1px solid #334155' : '1px solid #e2e8f0'),
                                                        borderRadius: '8px', padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'all 0.3s'
                                                    }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <span style={{ fontSize: '0.65rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 800, letterSpacing: '0.5px' }}>CAN. {index}</span>
                                                            <span style={{ fontSize: '0.9rem', color: darkMode ? '#f8fafc' : '#0f172a', fontWeight: 700 }}>{releNome}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <Typography style={{ fontSize: '0.7rem', fontWeight: 800, color: isOn ? '#10b981' : '#ef4444' }}>{isOn ? 'ATIVO' : 'ESPERA'}</Typography>
                                                            <Switch 
                                                                size="small" 
                                                                checked={isOn} 
                                                                onChange={() => handleClickPgm(isOn ? processarIndexDesativarRele(index) : processarIndexAtivarRele(index))} 
                                                                color="success"
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </div>
                            </div>
                        </Grid>

                        {/* ALARM SYSTEM SPATIAL */}
                        <Grid item xs={12} md={5}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                borderRadius: '12px',
                                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%',
                                position: 'relative',
                                display: 'flex', flexDirection: 'column'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '12px 12px 0 0' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><SensorsIcon fontSize="small"/> STATUS DO SISTEMA </span>
                                </div>
                                <div style={{ padding: '16px', flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Grid container spacing={2} style={{ height: '100%' }}>
                                        <Grid item xs={6}>
                                            <Tooltip 
                                                PopperProps={{
                                                    sx: {
                                                        zIndex: 11000
                                                    }
                                                }}
                                                title={
                                                <div style={{ backgroundColor: darkMode ? '#1e293b' : 'white', minHeight: "300px", minWidth: "400px", maxHeight: "300px", maxWidth: "400px", border: darkMode ? '1px solid #334155' : '1px solid black', color: darkMode ? '#f8fafc' : 'black', overflow: "auto" }}>
                                                    <Grid container direction="row" item xs={12} alignItems="center" justifyContent="flex-start">
                                                        <Typography style={{ padding: 1 }}>
                                                            <Box sx={{ whiteSpace: "pre-line" }}>
                                                                <span style={{fontWeight:'bold', display:'block', marginBottom:'10px', color: '#1976d2'}}>
                                                                    Atualizado em {moment(equipamento.modulo_pgm.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} ({moment(equipamento.modulo_pgm.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                                </span>
                                                                {equipamento.modulo_pgm.status_zonas && equipamento.modulo_pgm.status_zonas.split(";").filter(Boolean).map((linha) => {
                                                                    const [id, nome, zoneStatus, armeStatus, zoneAlarme] = linha.split(",");
                                                                    return <Zone key={id} zoneData={{ id, nome, zoneStatus, armeStatus, zoneAlarme }} />;
                                                                })}
                                                            </Box>
                                                        </Typography>
                                                    </Grid>
                                                </div>
                                            } placement="top" arrow>
                                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', height: '100%', minHeight: '120px', transition: 'all 0.2s', padding: '16px' }}>
                                                    <SensorsIcon style={{ fontSize: '40px', color: '#3b82f6' }}/>
                                                    <Typography style={{ fontSize: '0.85rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#0f172a', letterSpacing: '1px' }}>ZONAS</Typography>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Tooltip 
                                                PopperProps={{
                                                    sx: {
                                                        zIndex: 11000
                                                    }
                                                }}
                                                title={
                                                <div style={{ backgroundColor: darkMode ? '#1e293b' : 'white', minHeight: '300px', minWidth: '400px', border: darkMode ? '1px solid #334155' : '1px solid black', color: darkMode ? '#f8fafc' : 'black' }}>
                                                    <Grid container direction="row" item xs={12} alignItems="center" justifyContent="flex-start">
                                                        <Typography style={{ padding: 1 }}>
                                                            <Box sx={{ whiteSpace: 'pre-line', padding: '10px' }}>
                                                                <span style={{fontWeight:'bold', display:'block', marginBottom:'10px', color: '#9c27b0'}}>
                                                                    Atualizado em {moment(equipamento.modulo_pgm.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} ({moment(equipamento.modulo_pgm.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                                </span>
                                                                <span>{equipamento.modulo_pgm.status_central}</span>
                                                            </Box>
                                                        </Typography>
                                                    </Grid>
                                                </div>
                                            } placement="top" arrow>
                                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', height: '100%', minHeight: '120px', transition: 'all 0.2s', padding: '16px' }}>
                                                    <AccountTreeIcon style={{ fontSize: '40px', color: '#8b5cf6' }}/>
                                                    <Typography style={{ fontSize: '0.85rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#0f172a', letterSpacing: '1px' }}>PARTIÇÕES</Typography>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Grid container direction="row" justifyContent="center" align="center" item xs={3} style={{ padding: 1, margin: 0 }}>
                    <Grid container direction="row" justifyContent="center" align="center" item xs={12} style={{ boxShadow: alarme ? `0 0 30px 150px rgba(255, 0, 0, 0.5)` : "none" }}>
                        <Grid item xs={12}>
                            <img alt={"icone"} style={{ textAlign: 'center', width: '40px', height: '40px', filter: darkMode ? 'invert(1)' : 'none' }} src={processarIcone(tipo)} />
                        </Grid>
                        <Grid item xs={12}>
                            <Tooltip 
                                PopperProps={{
                                    sx: {
                                        zIndex: 11000
                                    }
                                }}
                                title={
                                <Typography style={{ padding: 1, fontSize: '12px' }}>
                                    Última conexão: {moment(equipamento.modulo_pgm.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}
                                </Typography>
                            } placement="top" arrow>
                                <span style={{ color: darkMode ? '#f8fafc' : '#0f172a', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' }}>{equipamento.modulo_pgm.codigo} </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12}>
                            <span style={{ color: statusColor, fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', animation: isBlinking ? 'blink 2s step-start infinite' : 'none' }}>
                                {statusText}
                            </span>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: '4px' }}>
                            <button
                                onClick={handleArmarDesarmarLocal}
                                disabled={loadingArmacao}
                                style={{
                                    backgroundColor: loadingArmacao ? '#94a3b8' : (estadoArmacaoLocal === 0 ? '#10b981' : '#ef4444'),
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '2px 8px',
                                    fontSize: '0.65rem',
                                    fontWeight: 700,
                                    cursor: loadingArmacao ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s',
                                    textTransform: 'uppercase',
                                    boxShadow: loadingArmacao ? 'none' : (estadoArmacaoLocal === 0 ? '0 0 8px rgba(16,185,129,0.3)' : '0 0 8px rgba(239,68,68,0.3)')
                                }}
                            >
                                {loadingArmacao ? `⏳ ${countdownArmacao}s` : (estadoArmacaoLocal === 0 ? '🛡️ ARMAR' : '🔓 DESARMAR')}
                            </button>
                        </Grid>
                    </Grid>
                </Grid>
            )}


            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',

                    }
                }}
            />


            {/* Modal Histórico de Eventos */}
            {openLogTable && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.75)",
                        zIndex: 199999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backdropFilter: "blur(4px)"
                    }}
                >
                    <div
                        style={{
                            width: "95vw",
                            height: "92vh",
                            backgroundColor: "#ffffff",
                            borderRadius: "12px",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            border: "1px solid #e2e8f0"
                        }}
                    >
                        {/* Modal Header */}
                        <div
                            style={{
                                backgroundColor: "#0f172a",
                                color: "#ffffff",
                                padding: "12px 20px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #1e293b"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <NotificationsActiveIcon style={{ color: "#38bdf8", fontSize: "22px" }} />
                                <span style={{ fontSize: "16px", fontWeight: "700", letterSpacing: "0.3px" }}>
                                    Histórico de Eventos - Módulo PGM
                                </span>
                                <span
                                    style={{
                                        backgroundColor: "#1e293b",
                                        color: "#38bdf8",
                                        fontSize: "12px",
                                        padding: "2px 10px",
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        border: "1px solid #334155"
                                    }}
                                >
                                    {rowCount} registros
                                </span>
                            </div>
                            <button
                                onClick={() => setOpenLogTable(false)}
                                style={{
                                    backgroundColor: "#ef4444",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "6px 14px",
                                    cursor: "pointer",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    transition: "all 0.2s"
                                }}
                            >
                                ✕ Fechar
                            </button>
                        </div>

                        {/* Top Toolbar: Search & Action Buttons */}
                        <div
                            style={{
                                backgroundColor: "#f8fafc",
                                padding: "10px 16px",
                                borderBottom: "1px solid #e2e8f0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "10px"
                            }}
                        >
                            {/* Search Input */}
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, maxWidth: "450px" }}>
                                <TextField
                                    size="small"
                                    placeholder="🔍 Buscar por ID, usuário, evento, IP ou zona..."
                                    variant="outlined"
                                    value={customSearch}
                                    onChange={(e) => setCustomSearch(e.target.value)}
                                    fullWidth
                                    style={{ backgroundColor: "#ffffff" }}
                                />
                            </div>

                            {/* Export & Action Buttons */}
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => fetchLogsData()}
                                    startIcon={<RefreshIcon />}
                                    variant="contained"
                                >
                                    Atualizar
                                </Button>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={handleExportDataPDF}
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                >
                                    Exportar PDF
                                </Button>
                                <Button
                                    size="small"
                                    style={{ backgroundColor: '#10b981', color: 'white' }}
                                    onClick={handleExportDataExcel}
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                >
                                    Exportar Excel
                                </Button>
                            </div>
                        </div>

                        {/* Table Area */}
                        <div style={{ flex: 1, overflow: "auto", padding: 0 }}>
                            {isFetchingLogs ? (
                                <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>
                                    <Typography style={{ fontWeight: "600", fontSize: "15px" }}>Carregando histórico de eventos...</Typography>
                                </div>
                            ) : (
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13.5px", textAlign: "left" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f1f5f9", borderBottom: "2px solid #cbd5e1", position: "sticky", top: 0, zIndex: 10 }}>
                                            <th style={{ padding: "10px 12px", width: "50px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>ID</th>
                                            <th style={{ padding: "10px 12px", width: "110px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Usuário</th>
                                            <th style={{ padding: "10px 12px", width: "140px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Data Requisição</th>
                                            <th style={{ padding: "10px 12px", width: "140px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Data Resposta</th>
                                            <th style={{ padding: "10px 12px", width: "160px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Tipo</th>
                                            <th style={{ padding: "10px 12px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Evento / Detalhes</th>
                                            <th style={{ padding: "10px 12px", width: "90px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Origem</th>
                                            <th style={{ padding: "10px 12px", width: "70px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Info</th>
                                            <th style={{ padding: "10px 12px", width: "65px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Imagem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredLogs.length === 0 ? (
                                            <tr>
                                                <td colSpan="9" style={{ padding: "30px", textAlign: "center", color: "#94a3b8", fontWeight: "600", fontSize: "14px" }}>
                                                    Nenhum evento encontrado.
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredLogs.map((row, idx) => {
                                                const logData = (row.valor_string1 || '') + ' ' + (row.valor_string2 || '') + ' ' + (row.valor_string3 || '');
                                                const rawTipoRequisicao = row.tipo_requisicao || '';
                                                
                                                let tipoEvento = rawTipoRequisicao;
                                                let ipDispositivo = row.valor_string1 || row.origem || 'N/A';
                                                let nomeZona = row.valor_string3 && row.valor_string3 !== 'null' ? row.valor_string3 : 'N/A';
                                                
                                                if (logData.includes('Zona:')) {
                                                    const match = logData.match(/Zona:\s*([^|]+)/);
                                                    if (match) nomeZona = match[1].trim();
                                                }

                                                const fullTextLower = (tipoEvento + ' ' + logData).toLowerCase();
                                                const isAlarme = fullTextLower.includes('alarme');
                                                const isArme = fullTextLower.includes('armar') || fullTextLower.includes('armado') || fullTextLower.includes('arme');
                                                const isDesarme = fullTextLower.includes('desarmar') || fullTextLower.includes('desarmado') || fullTextLower.includes('desarme');

                                                const user = row.usuario_criador?.nome_amigavel || row.usuario_criador?.nome || row.usuario_nome || row.nome_usuario || '-';

                                                let badgeColor = "#475569";
                                                let badgeBg = "#f1f5f9";
                                                let badgeBorder = "#e2e8f0";

                                                if (isAlarme) {
                                                    badgeColor = "#dc2626";
                                                    badgeBg = "#fef2f2";
                                                    badgeBorder = "#fecaca";
                                                } else if (isArme) {
                                                    badgeColor = "#16a34a";
                                                    badgeBg = "#f0fdf4";
                                                    badgeBorder = "#bbf7d0";
                                                } else if (isDesarme) {
                                                    badgeColor = "#d97706";
                                                    badgeBg = "#fffbeb";
                                                    badgeBorder = "#fde68a";
                                                }

                                                return (
                                                    <tr
                                                        key={row.id_tarefa || idx}
                                                        style={{
                                                            borderBottom: "1px solid #f1f5f9",
                                                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                                                            transition: "background 0.15s"
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? "#ffffff" : "#fafafa"}
                                                    >
                                                        {/* ID */}
                                                        <td style={{ padding: "8px 12px", fontWeight: "700", color: "#0f172a", fontSize: "13.5px" }}>
                                                            {row.id_tarefa}
                                                        </td>

                                                        {/* Usuário */}
                                                        <td style={{ padding: "8px 12px", fontWeight: "600", color: "#334155", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {user}
                                                        </td>

                                                        {/* Data Requisição */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {row.data_hora_requisicao || '-'}
                                                        </td>

                                                        {/* Data Resposta */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {row.data_hora_resposta || '-'}
                                                        </td>

                                                        {/* Tipo */}
                                                        <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                                                            <span style={{
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                color: badgeColor,
                                                                backgroundColor: badgeBg,
                                                                padding: "3px 8px",
                                                                borderRadius: "4px",
                                                                border: `1px solid ${badgeBorder}`
                                                            }}>
                                                                {rawTipoRequisicao || '-'}
                                                            </span>
                                                        </td>

                                                        {/* Evento */}
                                                        <td style={{ padding: "8px 12px" }}>
                                                            <div style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                backgroundColor: isAlarme ? "#fee2e2" : (isArme ? "#dcfce7" : (isDesarme ? "#fef3c7" : "#f8fafc")),
                                                                color: isAlarme ? "#991b1b" : (isArme ? "#166534" : (isDesarme ? "#92400e" : "#334155")),
                                                                border: `1px solid ${isAlarme ? "#fca5a5" : (isArme ? "#86efac" : (isDesarme ? "#fcd34d" : "#cbd5e1"))}`,
                                                                padding: "4px 10px",
                                                                borderRadius: "6px",
                                                                fontSize: "12.5px",
                                                                fontWeight: isAlarme ? "700" : "500",
                                                                maxWidth: "100%"
                                                            }}>
                                                                {isAlarme && <NotificationsActiveIcon style={{ color: "#dc2626", fontSize: "16px" }} />}
                                                                {isArme && <LockIcon style={{ color: "#16a34a", fontSize: "16px" }} />}
                                                                {isDesarme && <LockOpenIcon style={{ color: "#d97706", fontSize: "16px" }} />}
                                                                <span>{tipoEvento}</span>
                                                                {row.valor_string1 && <span style={{ color: "#64748b", fontWeight: "normal" }}>| IP: {row.valor_string1}</span>}
                                                                {nomeZona !== 'N/A' && <span style={{ color: "#64748b", fontWeight: "normal" }}>| Zona: {nomeZona}</span>}
                                                            </div>
                                                        </td>

                                                        {/* Origem */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", fontSize: "13px" }}>
                                                            {row.origem || '-'}
                                                        </td>

                                                        {/* Info Extra */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.valor_string2 ? (
                                                                <Tooltip
                                                                    title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: "12px", maxWidth: '450px' }}>{row.valor_string2}</pre>}
                                                                    arrow
                                                                    placement="left"
                                                                >
                                                                    <span style={{ cursor: 'pointer', color: '#3b82f6', textDecoration: 'underline', fontSize: '12.5px', fontWeight: 'bold' }}>Ver</span>
                                                                </Tooltip>
                                                            ) : null}
                                                        </td>

                                                        {/* Imagem */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.imagem_intrusao ? (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const url = processVideoUrl(row.imagem_intrusao);
                                                                        if (url) {
                                                                            setSelectedAlarmeImageUrl(url);
                                                                            setSelectedAlarmeData(row.data_hora_requisicao);
                                                                            setOpenAlarmeImage(true);
                                                                        }
                                                                    }}
                                                                    title="Ver Imagem de Intrusão"
                                                                >
                                                                    <PlayCircleOutlineIcon style={{ color: '#3b82f6', fontSize: '22px' }} />
                                                                </IconButton>
                                                            ) : <span style={{ color: '#cbd5e1', fontSize: '11px' }}>-</span>}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Pagination Footer */}
                        <div
                            style={{
                                backgroundColor: "#f8fafc",
                                padding: "10px 16px",
                                borderTop: "1px solid #e2e8f0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "13px",
                                color: "#475569"
                            }}
                        >
                            <div>
                                Exibindo <b>{filteredLogs.length}</b> de <b>{rowCount}</b> registros salvos
                            </div>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    Linhas por página:
                                    <select
                                        value={pagination.pageSize}
                                        onChange={(e) => {
                                            const newSize = Number(e.target.value);
                                            setPagination({ pageIndex: 0, pageSize: newSize });
                                            fetchLogsData(0, newSize);
                                        }}
                                        style={{ padding: "3px 6px", borderRadius: "4px", border: "1px solid #cbd5e1", fontSize: "12px" }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                    </select>
                                </label>

                                <div style={{ display: "flex", gap: "6px" }}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        disabled={pagination.pageIndex === 0}
                                        onClick={() => {
                                            const nextIndex = pagination.pageIndex - 1;
                                            setPagination(prev => ({ ...prev, pageIndex: nextIndex }));
                                            fetchLogsData(nextIndex, pagination.pageSize);
                                        }}
                                    >
                                        ◀ Anterior
                                    </Button>
                                    <span style={{ display: "flex", alignItems: "center", padding: "0 6px", fontWeight: "600" }}>
                                        Página {pagination.pageIndex + 1} de {Math.max(1, Math.ceil(rowCount / pagination.pageSize))}
                                    </span>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        disabled={(pagination.pageIndex + 1) * pagination.pageSize >= rowCount}
                                        onClick={() => {
                                            const nextIndex = pagination.pageIndex + 1;
                                            setPagination(prev => ({ ...prev, pageIndex: nextIndex }));
                                            fetchLogsData(nextIndex, pagination.pageSize);
                                        }}
                                    >
                                        Próxima ▶
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Imagem de Intrusão */}
            {openAlarmeImage && (
                <div
                    style={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: "299999",
                    }}
                    onClick={() => setOpenAlarmeImage(false)}
                >
                    <div
                        style={{
                            backgroundColor: "#1e293b",
                            borderRadius: "8px",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            position: "relative"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{
                            backgroundColor: "#3b82f6",
                            color: "#fff",
                            padding: "12px 16px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: "bold"
                        }}>
                            <span>Imagem de Intrusão - {selectedAlarmeData || ''}</span>
                            <button
                                onClick={() => setOpenAlarmeImage(false)}
                                style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    color: "#fff",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer"
                                }}
                            >
                                ✕
                            </button>
                        </div>
                        <div style={{ padding: "16px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#000" }}>
                            {selectedAlarmeImageUrl ? (
                                <img
                                    src={selectedAlarmeImageUrl}
                                    alt="Intrusão"
                                    style={{ maxWidth: "100%", maxHeight: "75vh", objectFit: "contain", borderRadius: "4px" }}
                                    onError={(e) => {
                                        console.error("Erro ao carregar imagem:", selectedAlarmeImageUrl);
                                    }}
                                />
                            ) : (
                                <span style={{ color: "#fff" }}>Carregando imagem...</span>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL MAPA */}
            <Modal
                isOpen={openModalMap}
                onRequestClose={() => setOpenModalMap(false)}
                style={{
                    content: {
                        top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                        marginRight: '-50%', transform: 'translate(-50%, -50%)',
                        width: '90%', maxWidth: '900px', height: '80vh',
                        padding: '0', borderRadius: '12px', overflow: 'hidden',
                        backgroundColor: darkMode ? '#0f172a' : '#fff', border: 'none'
                    },
                    overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 10000 }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ 
                        padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                    }}>
                        <Typography style={{ fontWeight: 800, color: darkMode ? '#f1f5f9' : '#1e293b' }}>
                            LOCALIZAÇÃO - {equipamento.nome} ({equipamento.modulo_pgm.codigo})
                        </Typography>
                        <IconButton onClick={() => setOpenModalMap(false)} size="small" style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>
                            <Close />
                        </IconButton>
                    </div>
                    
                    <div style={{ flex: 1, position: 'relative' }}>
                        <div ref={modalMapRef} style={{ width: '100%', height: '100%' }} />
                    </div>
                    
                    <div style={{ 
                        padding: '12px 24px', 
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc', 
                        borderTop: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                        fontSize: '0.75rem', color: darkMode ? '#94a3b8' : '#64748b',
                        textAlign: 'center'
                    }}>
                        Posição geográfica reportada pelo módulo.
                    </div>
                </div>
            </Modal>
        </>
    );


}

